module.exports = __webpack_public_path__ + "static/media/change_icon_off.8c740287.svg";